import { paths } from '@luxuryescapes/contract-business'
import requestUtils from 'api/requestUtils'

type BusinessCardResolveResponse = paths['/api/business-traveller/businesses/{businessId}/cards/resolve']['get']['responses'][200]['content']['application/json']

export type BusinessCardResolveResult = BusinessCardResolveResponse['result']

interface Params {
  businessId: string
}

async function requestResolveBusinessCards(params: Params) {
  const { businessId } = params

  const response = await requestUtils.get<BusinessCardResolveResponse>(
    `/api/business-traveller/businesses/${businessId}/cards/resolve?without_brand=1`,
    { credentials: 'include' },
  )

  return response.result
}

export default requestResolveBusinessCards
